<div  tabindex="-1">
    <!-- <div class="trx-details-card">
        <box class="casa-transaction-trx-item">
            <box class="trx-icon">
                <ng-container *ngIf="(popupData.merchantId || popupData.transactionCat); else noPhoto">
                  <img *ngIf="popupData.icon; else noPhoto"  [ngClass]="{'merchant-img': popupData.merchantId}" [src]="'./assets/images/trxicons/'+popupData.icon">
                </ng-container>
                 <ng-template #noPhoto>
                    {{ popupData.transactionDescription?.charAt(0)?.toUpperCase() }}
                </ng-template>
            </box>
            <box class="trx-details">
                <box class="trx-primary-info">
                    <span class="date">{{ popupData.transactionDate  | dateFormatter : "yyyy-mm-dd" }}</span>
                    <span class="title">{{ popupData.transactionDescription }}</span>
                </box>
                <box class="trx-secondary-info">
                  <span class="trx-tag">{{ popupData.transactionCat }}</span>
                    <span class="amount" [ngClass]="{'debit': popupData.dbcrFlag == 'D'}">
                        <span class="debit-sign">-</span>
                        <span class="credit-sign">+</span>
                        {{ popupData.transactionAmount  | currency : popupData.transactionCurrency : '' }}&nbsp;<em>{{ popupData.transactionCurrency }}</em>
                    </span>
                </box>
            </box>
        </box>
    </div> -->
    <!-- <h6 class="trx-title">Transaction Details</h6> -->
    <div class="trx-details trx-detail-form">
      
        <ng-container>
            <!-- <box class="account-info">
                <span class="info-lbl">Merchant Id</span>
                <span class="info-val">{{ popupData.merchantId }}</span>
            </box> -->
            <box class="account-info">
              <span class="info-lbl">{{'TRANSACTIONDETAILFORM.transactionDate' | translate}}</span>
              <span class="info-val">{{ popupData.transactionDate }}</span>
          </box>
            <box class="account-info">
                <span class="info-lbl">{{'TRANSACTIONDETAILFORM.transactionAmount' | translate}}</span>
                <span class="amount" [ngClass]="{'debit': popupData.dbcrFlag == 'D'}">
                    <em>{{ popupData.transactionAmount| currency : popupData.currency : '' }}&nbsp; </em>
                    <span class="debit-sign">-</span>
                    <span class="credit-sign">+</span>
                   
                </span>
                <!-- <span class="info-val">{{ popupData.transactionAmount }}</span></em> -->
            </box>
            <box class="account-info">
                <span class="info-lbl">{{'TRANSACTIONDETAILFORM.transactionCat' | translate}}</span>
                <span class="info-val">{{ popupData.transactionCat }}</span>
            </box>
            <box class="account-info">
                <span class="info-lbl">{{'TRANSACTIONDETAILFORM.transactionCurrency' | translate}}</span>
                <span class="info-val">{{ popupData.transactionCurrency }}</span>
            </box>
         
            <box class="account-info">
                <span class="info-lbl">{{'TRANSACTIONDETAILFORM.transactionDescription' | translate}}</span>
                <span class="info-val">{{ popupData.transactionDescription }}</span>
            </box>
            <box class="account-info">
                <span class="info-lbl">{{'TRANSACTIONDETAILFORM.transactionReference' | translate}}</span>
                <span class="info-val">{{ popupData.transactionReference }}</span>
            </box>
            <!-- <box class="account-info">
                <span class="info-lbl">{{'TRANSACTIONDETAILFORM.transactionRemarks' | translate}}</span>
                <span class="info-val">{{ popupData.transactionRemarks }}</span>
            </box> -->
            <!-- <box class="account-info">
                <span class="info-lbl">{{'TRANSACTIONDETAILFORM.valuedate' | translate}}</span>
                <span class="info-val">{{ popupData.valuedate | dateFormatter : "yyyy-mm-dd" }}</span>
            </box> -->
            <!-- <box class="account-info">
                <span class="info-lbl">Available balance</span>
                <span class="info-val">20000<em class="currency">USD</em></span>
            </box> -->
        </ng-container>
        
    </div>
</div>